// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }
  
  :root {
    /* Color Variables */
    --primary-yellow: #FFD700;
    --primary-grey: #333333;
    --secondary-grey: #4a4a4a;
    --light-grey: #f5f5f5;
    --white: #ffffff;
    --border-color: #dddddd;
    --error-red: #dc3545;
    --success-green: #28a745;
  
    /* Spacing Variables */
    --spacing-xs: 0.25rem;
    --spacing-sm: 0.5rem;
    --spacing-md: 1rem;
    --spacing-lg: 1.5rem;
    --spacing-xl: 2rem;
  
    /* Shadow Variables */
    --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);
    --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
    --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
  
  body {
    background-color: var(--light-grey);
    color: var(--primary-grey);
    line-height: 1.6;
  }


  .grey_btn{
     color:"grey"
}
  
  /* Global Button Styles */
  /* .custom-btn {
    padding: var(--spacing-sm) var(--spacing-md);
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.3s ease;
}

.custom-btn-primary {
    background-color: var(--primary-yellow);
    color: var(--primary-grey);
}

.custom-btn-secondary {
    background-color: var(--primary-grey);
    color: var(--white);
}

.custom-btn:hover {
    opacity: 0.9;
    transform: translateY(-1px);
} */
  
  /* Global Form Styles */
  /* .custom-form-group {
    margin-bottom: var(--spacing-md);
} */
  
  /* label {
    display: block;
    margin-bottom: var(--spacing-xs);
    font-weight: 500;
  }
  
  input, select, textarea {
    width: 100%;
    padding: var(--spacing-sm);
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 1rem;
  }
  
  input:focus, select:focus, textarea:focus {
    outline: none;
    border-color: var(--primary-yellow);
    box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
  } */
  
  /* Utility Classes */
  /* .text-align-center { text-align: center; }
  .text-align-right { text-align: right; }
  .text-align-left { text-align: left; }
  
  .margin-top-1 { margin-top: var(--spacing-sm); }
  .margin-top-2 { margin-top: var(--spacing-md); }
  .margin-top-3 { margin-top: var(--spacing-lg); }
  
  .margin-bottom-1 { margin-bottom: var(--spacing-sm); }
  .margin-bottom-2 { margin-bottom: var(--spacing-md); }
  .margin-bottom-3 { margin-bottom: var(--spacing-lg); }
  
  .padding-1 { padding: var(--spacing-sm); }
  .padding-2 { padding: var(--spacing-md); }
  .padding-3 { padding: var(--spacing-lg); } */`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,4DAA4D;EAC9D;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,wBAAwB;;IAExB,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;;IAElB,qBAAqB;IACrB,yCAAyC;IACzC,yCAAyC;IACzC,0CAA0C;EAC5C;;EAEA;IACE,mCAAmC;IACnC,0BAA0B;IAC1B,gBAAgB;EAClB;;;EAGA;KACG;AACL;;EAEE,yBAAyB;EACzB;;;;;;;;;;;;;;;;;;;;;;;GAuBC;;EAED,uBAAuB;EACvB;;GAEC;;EAED;;;;;;;;;;;;;;;;;;KAkBG;;EAEH,oBAAoB;EACpB;;;;;;;;;;;;;;8CAc4C","sourcesContent":["* {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  }\r\n  \r\n  :root {\r\n    /* Color Variables */\r\n    --primary-yellow: #FFD700;\r\n    --primary-grey: #333333;\r\n    --secondary-grey: #4a4a4a;\r\n    --light-grey: #f5f5f5;\r\n    --white: #ffffff;\r\n    --border-color: #dddddd;\r\n    --error-red: #dc3545;\r\n    --success-green: #28a745;\r\n  \r\n    /* Spacing Variables */\r\n    --spacing-xs: 0.25rem;\r\n    --spacing-sm: 0.5rem;\r\n    --spacing-md: 1rem;\r\n    --spacing-lg: 1.5rem;\r\n    --spacing-xl: 2rem;\r\n  \r\n    /* Shadow Variables */\r\n    --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  body {\r\n    background-color: var(--light-grey);\r\n    color: var(--primary-grey);\r\n    line-height: 1.6;\r\n  }\r\n\r\n\r\n  .grey_btn{\r\n     color:\"grey\"\r\n}\r\n  \r\n  /* Global Button Styles */\r\n  /* .custom-btn {\r\n    padding: var(--spacing-sm) var(--spacing-md);\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.custom-btn-primary {\r\n    background-color: var(--primary-yellow);\r\n    color: var(--primary-grey);\r\n}\r\n\r\n.custom-btn-secondary {\r\n    background-color: var(--primary-grey);\r\n    color: var(--white);\r\n}\r\n\r\n.custom-btn:hover {\r\n    opacity: 0.9;\r\n    transform: translateY(-1px);\r\n} */\r\n  \r\n  /* Global Form Styles */\r\n  /* .custom-form-group {\r\n    margin-bottom: var(--spacing-md);\r\n} */\r\n  \r\n  /* label {\r\n    display: block;\r\n    margin-bottom: var(--spacing-xs);\r\n    font-weight: 500;\r\n  }\r\n  \r\n  input, select, textarea {\r\n    width: 100%;\r\n    padding: var(--spacing-sm);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 4px;\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  input:focus, select:focus, textarea:focus {\r\n    outline: none;\r\n    border-color: var(--primary-yellow);\r\n    box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);\r\n  } */\r\n  \r\n  /* Utility Classes */\r\n  /* .text-align-center { text-align: center; }\r\n  .text-align-right { text-align: right; }\r\n  .text-align-left { text-align: left; }\r\n  \r\n  .margin-top-1 { margin-top: var(--spacing-sm); }\r\n  .margin-top-2 { margin-top: var(--spacing-md); }\r\n  .margin-top-3 { margin-top: var(--spacing-lg); }\r\n  \r\n  .margin-bottom-1 { margin-bottom: var(--spacing-sm); }\r\n  .margin-bottom-2 { margin-bottom: var(--spacing-md); }\r\n  .margin-bottom-3 { margin-bottom: var(--spacing-lg); }\r\n  \r\n  .padding-1 { padding: var(--spacing-sm); }\r\n  .padding-2 { padding: var(--spacing-md); }\r\n  .padding-3 { padding: var(--spacing-lg); } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
